// https://observablehq.com/@laotzunami/dichotomy-pyramid@1183
function _1(md){return(
md`# Dichotomy Pyramid`
)}

function _2(md){return(
md`### PG(3,2) Galois Geometry`
)}

function _dropdown(inputsGroup,select){return(
inputsGroup([
  [
    select({
      title: "Type",
      description: "Traits on pyramid.",
      options: ["IEI – INFp", "IEE – ENFp", "ILI – INTp", "ILE – ENTp", "LII – INTj", "LIE – ENTj", "LSI – ISTj", "LSE – ESTj", "SLI – ISTp", "SLE – ESTp", "SEI – ISFp", "SEE – ESFp", "ESI – ISFj", "ESE – ESFj", "EII – INFj", "EIE – ENFj"],
      value: "SLE – ESTp"
    })
    ,
    select({
      title: "Reference Frame",
      description: "Defines positive polarities.",
      options: ["IEI – INFp", "IEE – ENFp", "ILI – INTp", "ILE – ENTp", "LII – INTj", "LIE – ENTj", "LSI – ISTj", "LSE – ESTj", "SLI – ISTp", "SLE – ESTp", "SEI – ISFp", "SEE – ESFp", "ESI – ISFj", "ESE – ESFj", "EII – INFj", "EIE – ENFj"],
      value: "ILE – ENTp"
    })
    ,
   /* select({
      title: "Pyramid Space",
      description: "Categories on pyramid",
      options: ["Reinin", "Minaiev", "Bipyramid", "Jungian Compass", "Auguastan Compass", "Intersection"],
      value: "Reinin"
    })*/
  ]
])
)}

function* _canvas1(dropdown,width,Types,THREE,Reinin)
{ 
  // SET UP ------------------------------------
  const typeList = ["IEI – INFp", "IEE – ENFp", "ILI – INTp", "ILE – ENTp", "LII – INTj", "LIE – ENTj", "LSI – ISTj", "LSE – ESTj", "SLI – ISTp", "SLE – ESTp", "SEI – ISFp", "SEE – ESFp", "ESI – ISFj", "ESE – ESFj", "EII – INFj", "EIE – ENFj"]
  var selectedType = 0
  for(let i=0; i<16; i++){ if(dropdown[0][0] == typeList[i]){selectedType=i} }
  var baseType = 0
  for(let i=0; i<16; i++){ if(dropdown[0][1] == typeList[i]){baseType=i} }
  
  let radius = 7
  let s=.25 *width/900 *radius/7 //sprite resolution scale
  let pol = []
  for(let i=0; i<16; i++){ pol.push((Types[selectedType].pol[i]+Types[baseType].pol[i]+1)%2) }
  
  //constants
  let pi = Math.PI
  
  // scene
  const aspect = 0.58125 
  //const width = 500
  const height = width * aspect
  const scene = new THREE.Scene()
  
  // camera
  const camera = new THREE.PerspectiveCamera(32, width/height, 1, 1000) // field of view, aspect ratio, near, far plane
  camera.position.set( 42, 12, -30 ) // camera is +40 in z direction
  camera.lookAt( 0, 0, 0 )        // camera is looking at origin
  
  // renderer
  const renderer = new THREE.WebGLRenderer({antialias: true}) // most powerful all purpose renderer, with smooth edges
  renderer.setClearColor("#ffffff") // background color f6f6f6
  renderer.setSize(width, height) // set window size
  scene.fog = new THREE.Fog( 0xffffff, 45,80 );
  yield renderer.domElement 
  
  // camera controls
  const controls = new THREE.OrbitControls(camera, renderer.domElement); // allows mouse to move camera
  controls.enableZoom   = false  // disables zoom
  controls.enablePan    = false  // disables pan
  controls.enableRotate = true  // determines if camera can rotate
  controls.autoRotate = true
  controls.autoRotateSpeed = -1.5
 
  // MATERIALS ---------------------------------
  const material = new THREE.MeshLambertMaterial({color: 0xffff00, side: THREE.DoubleSide, transparent: true, depthWrite: false, opacity:.3, emissive: 0xffff00})
  const matNormal = new THREE.MeshNormalMaterial({side: THREE.DoubleSide, transparent: true, depthWrite: false, opacity:.1});
  const matSolidLine = new THREE.LineBasicMaterial( {color: 0x66ee88, dashSize: 1, gapSize: .5, transparent: true, opacity:1} );
  const matDashedLine = new THREE.LineDashedMaterial( {color: 0x000000, dashSize: 1, gapSize: .5, transparent: true} );
  
  // SHAPE ------------------------------------
  
  let pyramidPoints = [
    new THREE.Vector3( 0, 0, 0),       //0000
    new THREE.Vector3(-1, 1,-1),       //0001  <<
    new THREE.Vector3( 1,-1,-1),       //0010  <<
    new THREE.Vector3( 0, 0,-1),       //0011
    new THREE.Vector3(-1,-1, 1),       //0100  <<
    new THREE.Vector3(-1, 0, 0),       //0101
    new THREE.Vector3( 0,-1, 0),       //0110
    new THREE.Vector3(-1/3,-1/3,-1/3), //0111
    new THREE.Vector3( 1, 1, 1),       //1000  << Top
    new THREE.Vector3( 0, 1, 0),       //1001
    new THREE.Vector3( 1, 0, 0),       //1010
    new THREE.Vector3(1/3,1/3,-1/3),   //1011
    new THREE.Vector3( 0, 0, 1),       //1100
    new THREE.Vector3(-1/3,1/3,1/3),   //1101
    new THREE.Vector3(1/3,-1/3,1/3),   //1110
    new THREE.Vector3( 0, 0, 0)        //1111
  ]
  //reposition points
  let axis = new THREE.Vector3(1,0,-1)
  for(let i=0; i<pyramidPoints.length; i++){
    pyramidPoints[i].multiplyScalar(radius)
    pyramidPoints[i].applyAxisAngle( axis, -0.7)
  }
  //sprite
  function makeLabelCanvas(baseWidth, size, name, charge) {
    const borderSize = 10;
    const ctx = document.createElement('canvas').getContext('2d');
    const font =  `bold ${size}px calibri`;
    ctx.font = font;
    
    const textWidth = ctx.measureText(name).width; // measure how long the name will be
    
    const spriteWidth = baseWidth + borderSize * 2 * s;
    const spriteHeight = size + borderSize * 2 * s;
    ctx.canvas.width = spriteWidth;
    ctx.canvas.height = spriteHeight;

    // need to set font again after resizing canvas
    ctx.font = font;
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';

    if(charge==1){ctx.fillStyle ='#000000'}else{ctx.fillStyle ='#80FF9E'}; //0x66ee88
    ctx.fillRect(0, 0, spriteWidth, spriteHeight);

    // scale to fit but don't stretch
    const scaleFactor = Math.min(1, baseWidth / textWidth);
    ctx.translate(spriteWidth / 2, spriteHeight / 1.85);
    ctx.scale(scaleFactor, 1);
    if(charge==1){ctx.fillStyle ='#FFFFD0'}else{ctx.fillStyle ='#000000'}
    ctx.fillText(name, 0, 0);

    return ctx.canvas;
  } 
  
  let n=16  
  const root = new THREE.Group()
  const rootSprite = new THREE.Group()
  for(let i=1; i<n; i++){
    let trait = Reinin[i].num
    if(Types[selectedType].pol[i]==1){trait = Reinin[i].labelPlus}else{trait = Reinin[i].labelMinus}
    
    const canvas = makeLabelCanvas(s*(String(trait).length*37+80),  s*100, trait, pol[i])
    const texture = new THREE.CanvasTexture(canvas);
    texture.minFilter = THREE.LinearFilter;
    texture.wrapS = THREE.ClampToEdgeWrapping;
    texture.wrapT = THREE.ClampToEdgeWrapping
    const labelMaterial = new THREE.SpriteMaterial({map: texture,transparent: true,});
    const labelBaseScale = 0.01 / s * radius / 7;
    
    const label = new THREE.Sprite(labelMaterial);
    label.position.set(pyramidPoints[i].x, pyramidPoints[i].y, pyramidPoints[i].z)
    label.scale.x = canvas.width  * labelBaseScale ;
    label.scale.y = canvas.height * labelBaseScale;
    rootSprite.add(label)
  }
  
  // lines
  let pyramidLines = [8,4, 8,2, 8,1, 4,2, 4,1, 2,1, 8,3, 8,6, 8,5, 2,12, 2,9, 2,5, 1,10, 1,12, 1,6, 4,10, 4,9, 4,3, 8,7, 2,13, 4,11, 1,14, 10,5, 12,3, 9,6]
  for(let i=0; i < pyramidLines.length / 2; i++){
    const geometry = new THREE.BufferGeometry().setFromPoints([
      pyramidPoints[pyramidLines[2*i]],
      pyramidPoints[pyramidLines[2*i+1]]
    ]);
    const line = new THREE.Line(geometry, matSolidLine.clone() )
    
    if(pol[pyramidLines[2*i]]==1 && pol[pyramidLines[2*i+1]]==1 ){
      line.material.color.setHex(0x000000)
    }
    
    line.computeLineDistances()
    root.add(line)
  }
  
  //planes
  let pyramidPlanes = [8,4,2, 8,4,1, 8,2,1, 4,2,1, 8,4,3, 8,2,5, 8,1,6, 4,2,9, 4,1,10, 2,1,12]
  for(let i=0; i< pyramidPlanes.length/3; i++){
    const geoPlanes = new THREE.Geometry()
    geoPlanes.vertices.push(
      pyramidPoints[pyramidPlanes[3*i]],
      pyramidPoints[pyramidPlanes[3*i+1]],
      pyramidPoints[pyramidPlanes[3*i+2]]
    );
    geoPlanes.faces.push( new THREE.Face3( 0, 1, 2 ))
    geoPlanes.computeFaceNormals() // required to know how to light faces
    const mesh = new THREE.Mesh( geoPlanes, matNormal.clone() )
    if(pol[pyramidPlanes[3*i]]==1 && pol[pyramidPlanes[3*i+1]]==1 && pol[pyramidPlanes[3*i+2]]==1){
      mesh.material = material.clone()
    }
    if(selectedType == baseType){ mesh.material.opacity = .1}
    root.add(mesh)
  }
  
  //cones
  let coneRotation = [0,0,0,  1.91063324,0,pi/12,  1.1,0,2.4,  .65,0, 4.29]
  let pyramidCones = [8,6,3,  4,9,10,  1,10,12,  2,9,12]
  for(let i=0; i<4; i++){
    const geoCones = new THREE.ConeGeometry(radius*.9, radius*1.5*Math.sqrt(3), 24, 1, true, pi/4)
    geoCones.applyMatrix( new THREE.Matrix4().makeTranslation( 0,radius/1.55,0 ) );
    const cone = new THREE.Mesh( geoCones, matNormal.clone() );
    cone.material.opacity = .05
    if(pol[pyramidCones[3*i]]==1 && pol[pyramidCones[3*i+1]]==1 && pol[pyramidCones[3*i+2]]==1){
      cone.material = material.clone()
    }
    cone.rotation.set(coneRotation[3*i], coneRotation[3*i+1], coneRotation[3*i+2])
    if(selectedType == baseType){ cone.material.opacity = .05}
    root.add(cone)
  }
  
  //sphere
  if(pol[1] == 0 && pol[2] == 0 && pol[4] == 0 && pol[8] == 0){
    const geoSphere = new THREE.SphereGeometry(1.12*radius,32,32)
    const sphere = new THREE.Mesh(geoSphere,material)
    root.add(sphere)
  }
  
  
  // Light ---------------------------------------  
  const hemiLight = new THREE.HemisphereLight( 0xffffff, 0xffffff, 0.6 );
	hemiLight.color.setHSL( 0.6, .6, 0.6 );
	hemiLight.groundColor.setHSL( 0.095, .5, 0.75 );
	hemiLight.position.set( 0, 50, 0 );
  
  const dirLight = new THREE.DirectionalLight( 0xffffff, 1 );
	dirLight.color.setHSL( 0.1, 1, 0.95 );
	dirLight.position.set( - 1, 1.75, 1 );
	dirLight.position.multiplyScalar( 30 );
	scene.add( dirLight );
  
  // SCENE --------------------------------------
  const pickable = new THREE.Group()
  scene.add(pickable)
  scene.add(rootSprite)
  scene.add(root)
  scene.add( hemiLight )
  scene.add( dirLight )
  
  // RAYCASTER-----------------------------------
  const mouse = new THREE.Vector2(-.5,.25) // starts mouse position off screen so no objects are highlighted at start
  let intersected
  const raycaster = new THREE.Raycaster()
  raycaster.setFromCamera() 
  let x
  let y
  renderer.domElement.onmousemove = event => {
    event.preventDefault();
    console.log(event)
    x=event.layerX
    y=event.layerY
    mouse.x =  ( x / width ) * 2 - 1,
    mouse.y = -( y / height  ) * 2 + 1
  };
  
  
  
  //////////////////////////////////////////////////////////////////////////////////////////////
 // RENDER LOOP ///////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////
  let intersects
  let INTERSECTED;
  let t=0
  
  const render = function(){
    requestAnimationFrame(render) // adjust scale on resize and stops animation when window is closed to save memory
        
    // mouse actions
    raycaster.setFromCamera( mouse, camera ); //raycaster runs each animation frame
    intersects = raycaster.intersectObjects(pickable.children); // checks intersection
    
    // highlight object
    if ( intersects.length > 0 ) {
					if ( INTERSECTED != intersects[ 0 ].object ) {
						if ( INTERSECTED ) INTERSECTED.material.emissive.setHex( INTERSECTED.currentHex );
						INTERSECTED = intersects[ 0 ].object;
						INTERSECTED.currentHex = INTERSECTED.material.emissive.getHex();
						INTERSECTED.material.emissive.setHex( 0x444400 );
					}
				} else {
					if ( INTERSECTED ) INTERSECTED.material.emissive.setHex( INTERSECTED.currentHex );
					INTERSECTED = null;
				}
    
    // animation
    t+=.005;
    
    //offset labels
    var camPos = camera.position.clone().normalize().multiplyScalar(1.5) 
    rootSprite.position.set(camPos.x, camPos.y, camPos.z)
    
    controls.update()
    renderer.render(scene, camera) // renders scene
  }
    
  // Input -------------------------
  window.addEventListener('click', () => { INTERSECTED.material.color.setHex(Math.random()*0xffffff) })
  
  window.addEventListener('mouseover', () => { controls.autoRotate = false })
  window.addEventListener('mouseout', () => { controls.autoRotate = true })
  
  render();
}


function _5(md){return(
md`### Pyramid of Differences`
)}

function* _canvas3(width,THREE,Types)
{ 
  // SET UP ------------------------------------
  let radius = 1.5 // size of small pyramids
  const span = 4.5 // size of overall pyramid
  
  //constants
  let pi = Math.PI
  
  // scene
  const aspect = 1.02 //0.58125 
  //const width = 500
  const height = width * aspect
  const scene = new THREE.Scene()
  
  // camera
  const camera = new THREE.PerspectiveCamera(40, width/height, 1, 1000) // field of view, aspect ratio, near, far plane
  camera.position.set( 0, 30, 38 ) // camera is +40 in z direction
  camera.lookAt( 0, 0, 0 )        // camera is looking at origin
  
  // renderer
  const renderer = new THREE.WebGLRenderer({antialias: true}) // most powerful all purpose renderer, with smooth edges
  renderer.setClearColor("#ffffff") // background color f6f6f6
  renderer.setSize(width, height) // set window size
  scene.fog = new THREE.Fog( 0xffffff, 35,70 );
  yield renderer.domElement 
  
  // camera controls
  const controls = new THREE.OrbitControls(camera, renderer.domElement); // allows mouse to move camera
  controls.enableZoom   = false  // disables zoom
  controls.enablePan    = false  // disables pan
  controls.enableRotate = true  // determines if camera can rotate
  controls.autoRotate = true
  controls.autoRotateSpeed = -1.5
 
  // MATERIALS ---------------------------------
  const material = new THREE.MeshLambertMaterial({color: 0xffff00, side: THREE.DoubleSide, transparent: true, depthWrite: false, opacity:.4, emissive: 0xffff00})
  const matNormal = new THREE.MeshNormalMaterial({side: THREE.DoubleSide, transparent: true, depthWrite: false, opacity:.15});
  const matBlack = new THREE.MeshLambertMaterial({color: 0x000000, side: THREE.DoubleSide})
  const matSolidLine = new THREE.LineBasicMaterial( {color: 0x66ee88, dashSize: 1, gapSize: .5, transparent: true, opacity:1} );
  const matDashedLine = new THREE.LineDashedMaterial( {color: 0x66ee88, dashSize: .25, gapSize: .25, transparent: true, depthWrite: false, opacity:.4} );
  
  // SHAPE ------------------------------------
  
  // small pyramids
  let pyramidPoints = [
    new THREE.Vector3( -1, -1, -1),    //0000
    new THREE.Vector3(-1, 1,-1),       //0001  <<
    new THREE.Vector3( 1,-1,-1),       //0010  <<
    new THREE.Vector3( 0, 0,-1),       //0011
    new THREE.Vector3(-1,-1, 1),       //0100  <<
    new THREE.Vector3(-1, 0, 0),       //0101
    new THREE.Vector3( 0,-1, 0),       //0110
    new THREE.Vector3(-1/3,-1/3,-1/3), //0111
    new THREE.Vector3( 1, 1, 1),       //1000  << Top
    new THREE.Vector3( 0, 1, 0),       //1001
    new THREE.Vector3( 1, 0, 0),       //1010
    new THREE.Vector3(1/3,1/3,-1/3),   //1011
    new THREE.Vector3( 0, 0, 1),       //1100
    new THREE.Vector3(-1/3,1/3,1/3),   //1101
    new THREE.Vector3(1/3,-1/3,1/3),   //1110
    new THREE.Vector3( 0, 0, 0)        //1111
  ]
  //reposition points
  
  let axis = new THREE.Vector3(1,0,-1)
  for(let i=0; i<pyramidPoints.length; i++){
    pyramidPoints[i].multiplyScalar(radius)
    pyramidPoints[i].applyAxisAngle( axis, -0.7)
  }
  
  const root = new THREE.Group()
  const rootSprite = new THREE.Group()
  const dotList = []
  let n=16
  let lookup = [3,10,6,15,  14,7,11,2,  13,4,0,9,  8,1,5,12]
  for(let j=1; j<16; j++){
    
    //points
    for(let i=1; i<n; i++){
      const group1 = new THREE.Group();
      const square = new THREE.Mesh(new THREE.PlaneGeometry(.4,.4),matBlack.clone())
      group1.add(square)
      
      if(Types[lookup[j]].pol[i]==1){ 
        /*const shape1 = new THREE.Mesh(new THREE.PlaneGeometry(.25,.06),matBlack.clone())
        shape1.material.emissive.setHex(0xffffaa)
        shape1.position.set(0,0,.01)
        group1.add(shape1)
        const shape2 = new THREE.Mesh(new THREE.PlaneGeometry(.06,.25),matBlack.clone())
        shape2.material.emissive.setHex(0xffffaa)
        shape2.position.set(0,0,.01)
        group1.add(shape2)*/
      }else{
        square.material.emissive.setHex(0x80FF9E) //0x66ee88
        /*const shape1 = new THREE.Mesh(new THREE.PlaneGeometry(.25,.06),matBlack.clone())
        shape1.position.set(0,0,.01)
        group1.add(shape1)*/
      }
      group1.position.set(
        pyramidPoints[i].x + span*pyramidPoints[j].x, 
        pyramidPoints[i].y + span*pyramidPoints[j].y, 
        pyramidPoints[i].z + span*pyramidPoints[j].z
      )
      dotList.push(group1)
      rootSprite.add(group1)
    }

    // lines
    let pyramidLines = [8,4, 8,2, 8,1, 4,2, 4,1, 2,1, 8,3, 8,6, 8,5, 2,12, 2,9, 2,5, 1,10, 1,12, 1,6, 4,10, 4,9, 4,3, 8,7, 2,13, 4,11, 1,14, 10,5, 12,3, 9,6]
    for(let i=0; i < pyramidLines.length / 2; i++){
      const geometry = new THREE.BufferGeometry().setFromPoints([
        pyramidPoints[pyramidLines[2*i]],
        pyramidPoints[pyramidLines[2*i+1]]
      ]);
      const line = new THREE.Line(geometry, matSolidLine.clone() )

      if(Types[lookup[j]].pol[pyramidLines[2*i]]==1 && Types[lookup[j]].pol[pyramidLines[2*i+1]]==1 ){
        line.material.color.setHex(0x000000)
      }
      line.computeLineDistances()
      line.position.set(
        span*pyramidPoints[j].x, 
        span*pyramidPoints[j].y, 
        span*pyramidPoints[j].z
      )
      root.add(line)
    }

    //planes
    let pyramidPlanes = [8,4,2, 8,4,1, 8,2,1, 4,2,1, 8,4,3, 8,2,5, 8,1,6, 4,2,9, 4,1,10, 2,1,12]
    for(let i=0; i< pyramidPlanes.length/3; i++){
      const geoPlanes = new THREE.Geometry()
      geoPlanes.vertices.push(
        pyramidPoints[pyramidPlanes[3*i]],
        pyramidPoints[pyramidPlanes[3*i+1]],
        pyramidPoints[pyramidPlanes[3*i+2]]
      );
      geoPlanes.faces.push( new THREE.Face3( 0, 1, 2 ))
      geoPlanes.computeFaceNormals() // required to know how to light faces
      const mesh = new THREE.Mesh( geoPlanes, matNormal.clone() )
      if(Types[lookup[j]].pol[pyramidPlanes[3*i]]==1 && Types[lookup[j]].pol[pyramidPlanes[3*i+1]]==1 && Types[lookup[j]].pol[pyramidPlanes[3*i+2]]==1){
        
        mesh.material = material.clone()
        mesh.material.opacity = .4
      }
      mesh.position.set(
        span*pyramidPoints[j].x, 
        span*pyramidPoints[j].y, 
        span*pyramidPoints[j].z
      )
      root.add(mesh)
    }
    //cones
    let coneRotation = [0,0,0,  1.91063324,0,pi/12,  1.1,0,2.4,  .65,0, 4.29]
    for(let i=0; i<4; i++){
      if(i==0 && lookup[j]==13 || i==1 && lookup[j]==14 || i==2 && lookup[j]==10 || i==3 && lookup[j]==6){
        const geoCones = new THREE.ConeGeometry(radius*.9, radius*1.5*Math.sqrt(3), 24, 1, true, pi/4)
        geoCones.applyMatrix( new THREE.Matrix4().makeTranslation( 0,radius/1.55,0 ) );
        const cone = new THREE.Mesh( geoCones, material.clone() );
        cone.material.opacity = .2
        
        cone.rotation.set(coneRotation[3*i], coneRotation[3*i+1], coneRotation[3*i+2])
        cone.position.set(
          span*pyramidPoints[j].x, 
          span*pyramidPoints[j].y, 
          span*pyramidPoints[j].z
        )
        root.add(cone)
      }
    }

    //sphere
    if(j==12){
      const geoSphere = new THREE.SphereGeometry(1.12*radius,32,32)
      const sphere = new THREE.Mesh(geoSphere,material)
      sphere.material.opacity = .15
      root.add(sphere)
    }
  }
  
  // large pyramid frame
  let pyramidLines = [8,4, 8,2, 8,1, 4,2, 4,1, 2,1, 8,3, 8,6, 8,5, 2,12, 2,9, 2,5, 1,10, 1,12, 1,6, 4,10, 4,9, 4,3, 8,7, 2,13, 4,11, 1,14, 10,5, 12,3, 9,6]
  for(let i=0; i < pyramidLines.length / 2; i++){
    const geometry = new THREE.BufferGeometry().setFromPoints([
      pyramidPoints[pyramidLines[2*i]].clone().multiplyScalar(span+1),
      pyramidPoints[pyramidLines[2*i+1]].clone().multiplyScalar(span+1)
    ]);
    
   const line = new THREE.Line(geometry, matDashedLine.clone() )
   
   /*var geometry = new THREE.LineSegmentsGeometry();
   geometry.setPositions(
     pyramidPoints[pyramidLines[2*i]].clone().multiplyScalar(span+1),
     pyramidPoints[pyramidLines[2*i+1]].clone().multiplyScalar(span+1)
     )
   const line = new THREE.LineSegments2( geometry, new THREE.LineMaterial({
      linewidth: 10,
      resolution: {x: width, y:height}}));
    line.computeLineDistances();*/
   
   if(5<i && i<18 || 21<i){
     line.material.color.setHex(0x000000)
     line.material.color.setHex(0x000000)
     line.material.opacity = .2
    }
    line.computeLineDistances()
    line.position.set(0,0,0)
    root.add(line)
  }
  
  // SCENE --------------------------------------
  const pickable = new THREE.Group()
  scene.add(pickable)
  scene.add(rootSprite)
  scene.add(root)
  //scene.add( hemiLight )
  //scene.add( dirLight )
  
  // RAYCASTER-----------------------------------
  const mouse = new THREE.Vector2(-.5,.25) // starts mouse position off screen so no objects are highlighted at start
  let intersected
  const raycaster = new THREE.Raycaster()
  raycaster.setFromCamera() 
  let x
  let y
  renderer.domElement.onmousemove = event => {
    event.preventDefault();
    console.log(event)
    x=event.layerX
    y=event.layerY
    mouse.x =  ( x / width ) * 2 - 1,
    mouse.y = -( y / height  ) * 2 + 1
  };
  
  
  
  //////////////////////////////////////////////////////////////////////////////////////////////
 // RENDER LOOP ///////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////
  let intersects
  let INTERSECTED;
  let t=0
  
  const render = function(){
    requestAnimationFrame(render) // adjust scale on resize and stops animation when window is closed to save memory
        
    // mouse actions
    raycaster.setFromCamera( mouse, camera ); //raycaster runs each animation frame
    intersects = raycaster.intersectObjects(pickable.children); // checks intersection
    
    // highlight object
    if ( intersects.length > 0 ) {
					if ( INTERSECTED != intersects[ 0 ].object ) {
						if ( INTERSECTED ) INTERSECTED.material.emissive.setHex( INTERSECTED.currentHex );
						INTERSECTED = intersects[ 0 ].object;
						INTERSECTED.currentHex = INTERSECTED.material.emissive.getHex();
						INTERSECTED.material.emissive.setHex( 0x444400 );
					}
				} else {
					if ( INTERSECTED ) INTERSECTED.material.emissive.setHex( INTERSECTED.currentHex );
					INTERSECTED = null;
				}
    
    // animation
    t+=.005;
    
    //offset labels
    var camPos = camera.position.clone().normalize().multiplyScalar(.3) 
    rootSprite.position.set(camPos.x, camPos.y, camPos.z)
    
    for(let i=0; i<dotList.length; i++){
      dotList[i].quaternion.copy(camera.quaternion);
    }
    controls.update()
    renderer.render(scene, camera) // renders scene
  }
    
  // Input -------------------------
  window.addEventListener('click', () => { INTERSECTED.material.color.setHex(Math.random()*0xffffff) })
  
  window.addEventListener('mouseover', () => { controls.autoRotate = false })
  window.addEventListener('mouseout', () => { controls.autoRotate = true })
  
  render();
}


function _Types(){return(
[
  {type: 'IEI', pol:[1,1,0,0,1,1,0,0,0,0,1,1,0,0,1,1]}, //0
  {type: 'IEE', pol:[1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0]}, //1
  {type: 'ILI', pol:[1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0]}, //2
  {type: 'ILE', pol:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}, //3
  
  {type: 'LII', pol:[1,0,1,0,1,0,1,0,0,1,0,1,0,1,0,1]}, //4
  {type: 'LIE', pol:[1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0]}, //5
  {type: 'LSI', pol:[1,0,1,0,0,1,0,1,0,1,0,1,1,0,1,0]}, //6
  {type: 'LSE', pol:[1,0,1,0,0,1,0,1,1,0,1,0,0,1,0,1]}, //7
  
  {type: 'SLI', pol:[1,1,1,1,0,0,0,0,0,0,0,0,1,1,1,1]}, //8
  {type: 'SLE', pol:[1,1,1,1,0,0,0,0,1,1,1,1,0,0,0,0]}, //9
  {type: 'SEI', pol:[1,1,0,0,0,0,1,1,0,0,1,1,1,1,0,0]}, //10
  {type: 'SEE', pol:[1,1,0,0,0,0,1,1,1,1,0,0,0,0,1,1]}, //11
  
  {type: 'ESI', pol:[1,0,0,1,0,1,1,0,0,1,1,0,1,0,0,1]}, //12
  {type: 'ESE', pol:[1,0,0,1,0,1,1,0,1,0,0,1,0,1,1,0]}, //13
  {type: 'EII', pol:[1,0,0,1,1,0,0,1,0,1,1,0,0,1,1,0]}, //14
  {type: 'EIE', pol:[1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1]}  //15
]
)}

function _Reinin(){return(
[
  {num: '0', vector: '0000', labelPlus : 'Valid', labelMinus : 'Null'},
  {num: '1', vector: '0001', labelPlus : 'Irrational', labelMinus : 'Rational'},
  {num: '2', vector: '0010', labelPlus : 'Logical', labelMinus : 'Ethical'},
  {num: '3', vector: '0011', labelPlus : 'Constructivist', labelMinus : 'Emotivist'},
  {num: '4', vector: '0100', labelPlus : 'Intuitive', labelMinus : 'Sensory'},
  {num: '5', vector: '0101', labelPlus : 'Tactical', labelMinus : 'Strategic'},
  {num: '6', vector: '0110', labelPlus : 'Democratic', labelMinus : 'Aristocratic'},
  {num: '7', vector: '0111', labelPlus : 'Process', labelMinus : 'Result'},
  {num: '8', vector: '1000', labelPlus : 'Extravert', labelMinus : 'Introvert'},
  {num: '9', vector: '1001', labelPlus : 'Static', labelMinus : 'Dynamic'},
  {num: '10', vector: '1010', labelPlus : 'Yielding', labelMinus : 'Obstinate'},
  {num: '11', vector: '1011', labelPlus : 'Merry', labelMinus : 'Serious'},
  {num: '12', vector: '1100', labelPlus : 'Carefree', labelMinus : 'Farsighted'},
  {num: '13', vector: '1101', labelPlus : 'Judicious', labelMinus : 'Decisive'},
  {num: '14', vector: '1110', labelPlus : 'Positivist', labelMinus : 'Negativist'},
  {num: '15', vector: '1111', labelPlus : 'Asking', labelMinus : 'Declaring'}
]
)}

async function _THREE(require)
{
  const THREE = window.THREE = await require("three@0.96/build/three.min.js");
  await require("three@0.98/examples/js/controls/OrbitControls.js").catch(() => {});
  /*await require("three@0.98/examples/js/lines/LineSegmentsGeometry.js").catch(() => {});
  await require("three@0.98/examples/js/lines/LineGeometry.js").catch(() => {});
  await require("three@0.98/examples/js/lines/WireframeGeometry2.js").catch(() => {});
  await require("three@0.98/examples/js/lines/LineMaterial.js").catch(() => {});
  await require("three@0.98/examples/js/lines/LineSegments2.js").catch(() => {});
  await require("three@0.98/examples/js/lines/Line2.js").catch(() => {});
  await require("three@0.98/examples/js/lines/Wireframe.js").catch(() => {});*/
  return THREE;
}


export default function define(runtime, observer) {
  const main = runtime.module();
  main.define("module 1", async () => runtime.module((await import("./e93997d5089d7165@2303.js")).default));
  main.define("module 2", async () => runtime.module((await import("./7dfec509126263f5@315.js")).default));
  main.variable(observer()).define(["md"], _1);
  main.variable(observer()).define(["md"], _2);
  main.variable(observer("viewof dropdown")).define("viewof dropdown", ["inputsGroup","select"], _dropdown);
  main.variable(observer("dropdown")).define("dropdown", ["Generators", "viewof dropdown"], (G, _) => G.input(_));
  main.variable(observer("canvas1")).define("canvas1", ["dropdown","width","Types","THREE","Reinin"], _canvas1);
  main.variable(observer()).define(["md"], _5);
  main.variable(observer("canvas3")).define("canvas3", ["width","THREE","Types"], _canvas3);
  main.variable(observer("Types")).define("Types", _Types);
  main.variable(observer("Reinin")).define("Reinin", _Reinin);
  main.variable(observer("THREE")).define("THREE", ["require"], _THREE);
  main.define("select", ["module 1", "@variable"], (_, v) => v.import("select", _));
  main.define("inputsGroup", ["module 2", "@variable"], (_, v) => v.import("inputsGroup", _));
  return main;
}
